import { Directive, forwardRef, Input } from '@angular/core';
import {
  Validator,
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';

import { ValidationService } from './validation.service';

@Directive({
  selector:
    '[appPhonePatternCountryValidator][formControlName],[appPhonePatternCountryValidator][formControl],[appPhonePatternCountryValidator][ngModel]',
  standalone: false,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhonePatternCountryValidatorDirective),
      multi: true,
    },
  ],
})
export class PhonePatternCountryValidatorDirective implements Validator {
  @Input() phoneCountry: string;

  constructor(private validationService: ValidationService) {}

  validate(control: AbstractControl): ValidationErrors {
    const validator = this.validationService.phonePatternCountryValidator(
      this.phoneCountry
    );
    return validator(control);
  }
}
